/*
 * Plugin to save items (homes / Communities / images / floor plans )
 *
*/

var AdobeLaunch = require('./adobelaunch.js');
var savedItemsService = require('./savedItemsService.js');

(function ($) {

  this.$saveBtn = 'save-item';

  // vars definition
  var ITEM_ADDED = 'item:addedToMyAccount',
    $document = $(document),
    $body = $(document.body);

  $(window).on('changeTab', changeFloorPlanTabs);

  /*
   * changeFloorPlanTabs: listen the tabs changing and
   * reset the save button.
   * @param {data} data
  */
  function changeFloorPlanTabs(data) {
    FLOOR_PLAN_DATA_SAVE = $('.' + this.$saveBtn).attr('data-save');
    $('.' + this.$saveBtn).attr('data-ifp-id', data.target.dataset.ifpId);
    //@TODO include the save/start customizing btns into the tabs function
    if (FLOOR_PLAN_DATA_SAVE === 'true') {
      var saveTxt = $('.' + this.$saveBtn).data('saveText');
      $('.' + this.$saveBtn).attr('data-save', false);
      $('.' + this.$saveBtn).text(saveTxt);
    }
  }

  /*
   * bind click events
   *
  */
  $document.on('click', '.' + this.$saveBtn, saveItem.bind());
  $document.on('keydown', '.' + this.$saveBtn, function (e) {
    // Detect Enter defensively: e.key can be undefined in older browser / jQuery event shims used
    // elsewhere in this codebase, so fall back to keyCode / which (13) like other handlers do.
    var isEnterKey = e.key === 'Enter' || e.keyCode === 13 || e.which === 13;
    if (!isEnterKey) { return; }

    // Native interactive elements activate on Enter by themselves and their click bubbles up to the
    // delegated '.save-item' handler with the correct target, so synthesizing another click here
    // would either double-fire or run saveItem() against the wrong element.
    var nativeInteractiveSelector = 'a[href], button, input, select, textarea';

    // 1) The '.save-item' control itself is natively interactive (e.g. carousel v2 <button>): let the
    //    browser handle Enter.
    if ($(e.currentTarget).is(nativeInteractiveSelector)) { return; }

    // 2) The key event originated on a natively interactive descendant (e.g. an <a> inside a
    //    non-interactive '.save-item' <div>, as in PlanInteractiveTool). Firing a click on the
    //    wrapper would call saveItem() with e.target === wrapper, which has no dataset / anti-forgery
    //    token siblings and breaks the request. Let the descendant handle activation instead.
    if (e.target !== e.currentTarget && $(e.target).is(nativeInteractiveSelector)) { return; }

    // Otherwise this is a non-interactive '.save-item' being activated via the keyboard; synthesize
    // the click so the delegated handler runs.
    e.preventDefault();
    $(e.currentTarget).trigger('click');
  });

  // Expose the saved state (aria-current) on the control a screen reader actually focuses/announces.
  // When the .save-item element is itself interactive (e.g. carousel v2 <button>, or an <a>
  // save-item), the state goes on it directly; when it is a non-interactive wrapper (e.g.
  // PlanInteractiveTool's <div class="save-item"> around an <a>), the state goes on the nearest
  // interactive descendant instead of the wrapper (which is never focused/announced).
  var interactiveSelector = 'a, button, input, select, textarea, [role="button"], [tabindex]';
  function setAriaCurrentFor($el, isSaved) {
  	var $saveItem = $el.closest('.save-item');
    if (!$saveItem.length) { return; }
    	var $control = $saveItem.is(interactiveSelector) ? $saveItem : $saveItem.find(interactiveSelector).first();
    	if (!$control.length) { $control = $saveItem; }
    	$control.attr('aria-current', isSaved ? 'true' : 'false');
  }

  /*
   *
   * toggleStatus: changes the save status of that element
   * @param {$target} the element to check
   * @param {saveAction} wheter the action performed was a Save or an Unsave
   *
  */
  function toggleStatus($target, saveAction) {
    var doSaveText = $target.data('save-text'),
      doUnsaveText = $target.data('unsave-text'),
      doSaveClass = 'icon-heart',
      doSaveClassBtn = 'btn-black',
      doUnSaveClass = 'icon-heart-filled';

    // aria-current is updated via the setAriaCurrentFor($target, saveAction) helper defined above.

    if (saveAction) {
      $target.text(doUnsaveText);
      $target.data('is-saved', "True");
      $target.attr('data-is-saved', "True");
      if ($target.is('img')) {
        $target.attr('src', $target.data('saveImgSavedSrc'));
        $target.attr('alt', $target.data('saveImgSavedAlt'));
      }
      if ($target.hasClass(doSaveClass)) {
        $target.removeClass(doSaveClass);
        $target.addClass(doUnSaveClass);
      }
      if ($target.data("media-location")) {
        var commonUnsaveLocations = $("[data-media-location='" + $target.data("media-location") + "']");
        commonUnsaveLocations.removeClass(doSaveClass)
        commonUnsaveLocations.addClass(doUnSaveClass)
        commonUnsaveLocations.text(doUnsaveText)
        commonUnsaveLocations.data('is-saved', "True")
        commonUnsaveLocations.attr('data-is-saved', "True");
        // Keep the interactive Save control for every duplicate location in sync so screen
        // readers don't announce stale state on the other matching controls.
        commonUnsaveLocations.each(function () { setAriaCurrentFor($(this), true); });
      }
    } else {
      $target.text(doSaveText);
      $target.data('is-saved', "False");
      $target.attr('data-is-saved', "False");
      if ($target.is('img')) {
        $target.attr('src', $target.data('saveImgUnsavedSrc'));
        $target.attr('alt', $target.data('saveImgUnsavedAlt'));
      }
      if ($target.hasClass(doUnSaveClass)) {
        $target.removeClass(doUnSaveClass);
        $target.addClass(doSaveClass);
      }
      if ($target.data("media-location")) {
        var commonSaveLocations = $("[data-media-location='" + $target.data("media-location") + "']");
        commonSaveLocations.removeClass(doUnSaveClass)
        commonSaveLocations.addClass(doSaveClass)
        commonSaveLocations.text(doSaveText)
        commonSaveLocations.data('is-saved', "False")
        commonSaveLocations.attr('data-is-saved', "False");
        // Keep the interactive Save control for every duplicate location in sync so screen
        // readers don't announce stale state on the other matching controls.
        commonSaveLocations.each(function () { setAriaCurrentFor($(this), false); });
      }
    }

    // Set sr-only text on save or unsave.
    var $control = $target.closest('a.save-item, button.save-item');
    var $srOnly = $control.length ? $control.find('.sr-only').first() : $target.siblings('.sr-only').first();
    if ($srOnly.length > 0) {
      var baseSrOnlyText = 'Save Item';
      var srOnlyText = baseSrOnlyText + (saveAction ? '. This item has been saved to your saved items.' : '. This item has been removed from your saved items.');
      $srOnly.text(srOnlyText);
    }

    if ($target.hasClass('btn')) {
      $target.toggleClass(doSaveClassBtn, saveAction);
    }

    // Reflect the saved state on the toggled control (covers controls that have no
    // data-media-location group). saveAction === true means the item is now saved.
    setAriaCurrentFor($target, saveAction);
  }

  /*
   *
   * isSaved: determines whether the item is saved, based on the class or text
   * @param {$target} the element to check
   *
  */
  function isSaved($target) {
    return $target.hasClass('icon-heart-filled') || $target.hasClass('btn-black') || $target.hasClass('label-unsaved') || $target.data('is-saved') === "True";
  }

  /*
   *
   * saveItem: main ajax request type POST to send a data item to the API
   * @elem {e} e clicked element
   *
  */
  function saveItem(e) {
    var saveIcon, $saveIcon, actionToPerform, itemData;

    saveIcon = e.target;

    ensureDataAttributesArePresent();

    $saveIcon = $(saveIcon);
    var tokenField = $saveIcon.siblings('input[name="__RequestVerificationToken"]');
    var token = tokenField && tokenField.length != 0 ? tokenField.val() : "";
    actionToPerform = isSaved($saveIcon); //true: do Save; false: do Unsave

    e.preventDefault();

    itemData = {
      CommunityBrand: saveIcon.dataset.communityBrand,
      CommunityId: saveIcon.dataset.communityId,
      PlanId: saveIcon.dataset.planId,
      QmiId: saveIcon.dataset.qmiId,
      MediaLocation: saveIcon.dataset.mediaLocation || saveIcon.dataset.ifpId,
      ToolType: saveIcon.dataset.toolType,
      Caption: saveIcon.dataset.imageCaption,
      DeleteAction: actionToPerform
    };

    if (saveIcon.dataset.thumbnailUrl != null) {
      itemData['Thumbnail'] = saveIcon.dataset.thumbnailUrl;
    }

    // if this save icon already has a page url in it's dataset, use that instead of the current url
    itemData.pageUrl = saveIcon.dataset.pageUrl ? saveIcon.dataset.pageUrl : window.location.origin + window.location.pathname;
    itemData.__RequestVerificationToken = token;

    if (window.Pulte.user === undefined) {
      //Unauthenticated user: display login/create account modal
      itemData.SaveElement = true;
      $body.trigger('OPEN_ACCOUNT_MODAL', itemData);

    } else {
      //Authenticated user: Save item
      itemData.UserId = window.Pulte.user.UserId;
      itemData.SessionId = window.Pulte.user.SessionId;

      $.ajax({
        context: this,
        url: '/api/save/SaveItem',
        dataType: 'text',
        type: 'post',
        contentType: 'application/x-www-form-urlencoded',
        data: itemData,
        success: function (data, textStatus, sResponse) {
          if (sResponse.status === 200) {

            toggleStatus($saveIcon, !actionToPerform);

            updateAriaMessaging();

            // if we're saving the item, trigger the Adobe Launch event
            if (!itemData.DeleteAction) {
              switch (itemData.ToolType) {
                case savedItemsService.itemTypes.Community:
                  AdobeLaunch.pushItemSavedEvent(itemData.CommunityId, itemData.CommunityBrand, itemData.PlanId, itemData.QmiId, AdobeLaunch.COMMUNITY_SAVED_EVENT_NAME);
                  break;
                case savedItemsService.itemTypes.Plan:
                case savedItemsService.itemTypes.QMI:
                  AdobeLaunch.pushItemSavedEvent(itemData.CommunityId, itemData.CommunityBrand, itemData.PlanId, itemData.QmiId, AdobeLaunch.PLAN_SAVED_EVENT_NAME);
                  break;
                case savedItemsService.itemTypes.AV:
                  AdobeLaunch.pushItemSavedEvent(itemData.CommunityId, itemData.CommunityBrand, itemData.PlanId, itemData.QmiId, AdobeLaunch.INTERACTIVE_FLOOR_PLAN_SAVED_EVENT_NAME);
                  break;
              }
            }

            // toggle other save buttons on page as necessary (for communities/plans/qmis in Home Design Summary List, Product Map, Product Summary, 
            // and Grid View)
            if (itemData.CommunityId && itemData.ToolType) {
              var $saveButtons;

              if (itemData.QmiId && itemData.ToolType == savedItemsService.itemTypes.QMI) {
                $saveButtons = $("[data-qmi-id='" + itemData.QmiId + "'][data-plan-id='" + itemData.PlanId + "'][data-community-id='" + itemData.CommunityId + "'][data-tool-type='" + itemData.ToolType + "']");
              } else if (itemData.PlanId && itemData.ToolType == savedItemsService.itemTypes.Plan) {
                $saveButtons = $("[data-plan-id='" + itemData.PlanId + "'][data-community-id='" + itemData.CommunityId + "'][data-tool-type='" + itemData.ToolType + "']");
              } else if (itemData.ToolType == savedItemsService.itemTypes.Community) {
                $saveButtons = $("[data-community-id='" + itemData.CommunityId + "'][data-tool-type='" + itemData.ToolType + "']");
              } else if (itemData.ToolType == savedItemsService.itemTypes.FloorPlan || itemData.ToolType == savedItemsService.itemTypes.AV) {
                $saveButtons = $("[data-plan-id='" + itemData.PlanId + "'][data-community-id='" + itemData.CommunityId + "'][data-tool-type='" + itemData.ToolType + "']");
              }

              if ($saveButtons) {
                $saveButtons.each(function () {
                  if ($(this) != $saveIcon) {
                    toggleStatus($(this), !actionToPerform);
                  }
                });
              }
            }

            if (itemData.ToolType) {
              //Temporary Save
              if (!actionToPerform) {
                savedItemsService.addTemporarySavedItem(itemData)
              }
              //Temporary Delete 
              else {
                if (itemData.QmiId && itemData.ToolType == savedItemsService.itemTypes.QMI) {
                  savedItemsService.removeTemporarySavedItem(itemData.ToolType, itemData.QmiId, "qmiId")
                }
                else if (itemData.PlanId && itemData.ToolType == savedItemsService.itemTypes.Plan) {
                  savedItemsService.removeTemporarySavedItem(itemData.ToolType, itemData.PlanId, "planId")
                }
                else if (itemData.ToolType == savedItemsService.itemTypes.Community) {
                  savedItemsService.removeTemporarySavedItem(itemData.ToolType, itemData.CommunityId, "communityId")
                } else if (itemData.ToolType == savedItemsService.itemTypes.Image) {
                  savedItemsService.removeTemporarySavedItem(itemData.ToolType, itemData.MediaLocation, "url")
                }
                else if (itemData.PlanId && itemData.ToolType == savedItemsService.itemTypes.FloorPlan) {
                  savedItemsService.removeTemporarySavedItem(itemData.ToolType, itemData.PlanId, "planId")
                }
              }
            }
          }

          function updateAriaMessaging() {
            // The save control can be an <a> (grid/list views) or a <button> (carousel v2),
            // so walk up to the nearest interactive ancestor rather than assuming an anchor.
            var $control = $saveIcon.closest('a, button');
            var $messageSpan = $control.find('.sr-only');

            if ($messageSpan.length) { // if the save has not been updated for ADA, nothing will happen
              var carousel = itemData.ToolType == "Image" ? "Carousel " : "";
              var saveOrDeletedText = actionToPerform ? "removed from" : "saved to";
              $messageSpan.text(carousel + 'Save Item. This item has been ' + saveOrDeletedText + ' your saved items.');
            }
          }

        }
      });
    }

    return false;

    function ensureDataAttributesArePresent() {
      // A screen-reader-only span can be the click/keyboard target; walk up to the
      // interactive control (anchor OR button) that wraps it.
      if (saveIcon.tagName == 'SPAN' && saveIcon.classList.contains("sr-only")) {
        var $srControl = $(saveIcon).closest('a, button');
        if ($srControl.length) {
          saveIcon = $srControl[0];
        }
      }
      // The interactive control (A or BUTTON) is a wrapper; the required data-* attributes live on
      // an inner element (img / i / span). This matters for keyboard activation, where e.target is
      // the <button> itself (e.g. carousel v2 .save-item), so normalize to the descendant that
      // actually carries the dataset.
      if (saveIcon.tagName == 'A' || saveIcon.tagName == 'BUTTON') {
        var newSaveIcon =
          $(saveIcon).find('img')[0] ||
          $(saveIcon).find('i')[0] ||
          $(saveIcon).find('span[data-tool-type], span[data-media-location]')[0] ||
          $(saveIcon).find('span')[0];

        if (newSaveIcon && newSaveIcon.dataset) {
          saveIcon = newSaveIcon;
        }
      }
    }
  }

})(jQuery);
